export default class Language {
    constructor (rawData = {}) {
        this.id = rawData.id;
        this.locale = rawData.locale;
        this.description=rawData.description;
        this.isActive=rawData.isActive;
        this.isDefault=rawData.isDefault;
    }
}